import { __ } from "@wordpress/i18n";
import {
  PanelBody,
  SelectControl,
  ToggleControl,
  TextControl,
} from "@wordpress/components";

const POSITION_OPTIONS = [
  { label: __("Center", "brandy-blocks"), value: "center" },
  { label: __("Top", "brandy-blocks"), value: "top" },
  { label: __("Bottom", "brandy-blocks"), value: "bottom" },
  { label: __("Left Drawer", "brandy-blocks"), value: "left-drawer" },
  { label: __("Right Drawer", "brandy-blocks"), value: "right-drawer" },
];

export default function ModalSettings({ attributes, setAttributes }) {
  const {
    modalPosition = "center",
    showOnce = false,
    modalId = "",
  } = attributes;

  return (
    <PanelBody
      title={__("Modal Settings", "brandy-blocks")}
      initialOpen={true}
    >
      <SelectControl
        label={__("Position", "brandy-blocks")}
        value={modalPosition}
        options={POSITION_OPTIONS}
        onChange={(value) => {
          const updates = { modalPosition: value };
          if (value !== "center") {
            updates.animationType = "slide";
          }
          setAttributes(updates);
        }}
      />
      <ToggleControl
        label={__("Show Once", "brandy-blocks")}
        help={__("Only display this modal once per visitor.", "brandy-blocks")}
        checked={showOnce}
        onChange={(value) => setAttributes({ showOnce: value })}
      />
      <TextControl
        label={__("Modal ID", "brandy-blocks")}
        help={__(
          "Used for anchor links: <a href=\"#your-id\">",
          "brandy-blocks"
        )}
        value={modalId}
        onChange={(value) => setAttributes({ modalId: value })}
      />
    </PanelBody>
  );
}
